import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { SerialNoCellComponent } from '../../table-cell/serial-no-cell.component';
import { MasterSearchTransmissionService } from '../../services/raintree/Transmission/master-search.service';
import {
  GlobalRespo,
  GlobalResponseData,
} from '../../services/raintree/interfaces/global-respo';
import { DpTableComponent } from '../../common-component/dp-table/dp-table.component';
import { StatusCellComponent } from '../../table-cell/status-cell.component';
import { NamesToUpdateService } from '../../services/raintree/Transmission/names-to-update.service';
import {
  AssignDataRes,
  FWNamesResponse,
} from '../../services/raintree/interfaces/names-to-update.interface';
import { DpSuccessMessageComponent } from '../../common-component/dp-success-message/dp-success-message.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'fw-assign-dialog',
  standalone: true,
  templateUrl: './fw-assign-dialog.component.html',
  styleUrls: [
    './fw-assign-dialog.component.scss',
    '../../../styles/_dropdown.scss',
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DpTableComponent,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
  ],
})
export class FWAssignDialogComponent implements OnInit {
  districtName!: string;
  stateName!: string;
  fwNames: any = [];
  selectedValue!: string;
  selectedEmail!: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<FWAssignDialogComponent>,
    private _namesToUpdateService: NamesToUpdateService,
    private dialog: MatDialog,
    private _toastr: ToastrService
  ) {}
  responseData: any = [];

  ngOnInit(): void {
    this.districtName = this.data.selectedDistrict;
    this.stateName = this.data.selectedState;
    let queryParamsObj = {
      uiState: this.stateName,
      uiDistrict: this.districtName,
    };

    this._namesToUpdateService.getFWNames(queryParamsObj).subscribe({
      next: (response: FWNamesResponse) => {
        this.fwNames = response.data.map((user: any) => {
          return {
            label: user.first_name +' '+ user.last_name,
            value: user.id,
            email: user.email_id,
          };
        });
      },
      error: (error) => console.log(error),
    });
  }

  onChange(event: any): void {
    this.selectedValue = event.value;
    this.selectedEmail = this.fwNames.find(
      (ele: any) => ele.value == this.selectedValue
    ).email;
  }

  assignToFW() {
    let paramsObj = {
      memCodes: JSON.stringify([this.data.memCodes]),
    };

    let bodyObj = {
      assignedToId: this.selectedValue,
      assignedTo: this.selectedEmail,
      uiState: this.stateName,
      uiDistrict: this.districtName,
    };

    this._namesToUpdateService.assignDataToFW(paramsObj, bodyObj).subscribe({
      next: (res: AssignDataRes) => {
        this.dialog.open(DpSuccessMessageComponent, {
          panelClass: 'common-pannel-dialog-container',
          data: {
            mainHeading: 'Assigned Data Successfully',
            buttonValue: 'Done',
          },
        });
        this.dialogRef.close(true);
      },
      error: (error) => {
        this._toastr.error(error);
      },
    });
  }

  closeFWDialog() {
    this.dialogRef.close();
  }
}
